import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import LoadingBar from 'react-redux-loading-bar';
import { capitalize, get } from 'lodash';

import withSidebarStateAndContext from '../common/hoc/withSidebarStateAndContext';
import Main from '../main/main';
import Sidebar from '../sidebar/sidebar';
import { fetchShops } from './shops/actions';
import { GLYPHS } from '../common/icon';
import withCollapsed from '../sidebar/withCollapsed';
import { subscribe, unsubscribe } from '../common/pubnub';
import { getCurrentUserId } from '../auth/selectors';
import withNotifications from '../common/withNotifications';

class AdminApp extends Component {
  componentDidMount() {
    this.subscribeNotificationListener(this.props.userId);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.userId && nextProps.userId) {
      this.subscribeNotificationListener(nextProps.userId);
    }
  }

  componentWillUnmount() {
    unsubscribe(`admin_user_${this.props.userId}`);
  }

  subscribeNotificationListener(userId) {
    if (!userId) return;
    subscribe({
      channel: `admin_user_${userId}`,
      message: ({ message }) => {
        this.notifications(message);
      },
    });
  }

  notifications(args) {
    const notification = get(args, 'notification');

    if (notification) {
      this.props.addNotification({
        title: capitalize(notification.type),
        level: notification.type,
        message: notification.message,
        autoDismiss: 20,
        position: 'tr',
      });
    }
  }

  render() {
    const data = [{
      id: 'brands',
      text: 'Brands',
      iconName: GLYPHS.bold,
      url: '/admin/brands',
      show: true,
    }, {
      id: 'shops',
      text: 'Shops',
      iconName: GLYPHS.shop,
      url: '/admin/shops',
      show: true,
    }, {
      id: 'users',
      text: 'Users',
      iconName: GLYPHS.customers,
      url: '/admin/users',
      show: true,
    }, {
      id: 'clients',
      text: 'Clients',
      iconName: GLYPHS.adminCustomers,
      url: '/admin/customers',
      show: true,
    }, {
      id: 'commissionSplits',
      text: 'Commission/Tip Splits',
      iconName: GLYPHS.analytics,
      url: '/admin/commission-splits',
      show: true,
    }, {
      id: 'subscriptionPlans',
      text: 'Subscription Plans',
      iconName: GLYPHS.banknote,
      url: '/admin/subscription/plans',
      show: true,
    },
    ];

    const className = classnames({
      collapse: this.props.collapsed,
      expand: !this.props.collapsed,
    });

    return (
      <div>
        <LoadingBar className="c-loading-bar" />
        <Sidebar
          navData={data}
          collapsed={this.props.collapsed}
          setCollapsed={this.props.setCollapsed}
        />
        <Main marginClass={className}>
          {this.props.children}
        </Main>
      </div>
    );
  }
}

AdminApp.propTypes = {
  children: PropTypes.node.isRequired,
  fetchShops: PropTypes.func.isRequired,
  collapsed: PropTypes.bool.isRequired,
  setCollapsed: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  addNotification: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  userId: getCurrentUserId(state),
});

const mapDispatchToProps = {
  fetchShops,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNotifications,
  withSidebarStateAndContext,
  withCollapsed,
)(AdminApp);
